export default __webpack_public_path__ + "static/media/pexels-mental-health-america-(mha)-5543181.12ac80af.jpg";